import { NotificationManager } from 'helpers/NotificationsManager'
import { API } from 'network'
import { handleErrorNotification } from 'services/ErrorHandlingService'
import _ from 'lodash-es'
import { STRIKE_STATUS } from 'models/Strike'
import { OpenModal, CloseModal } from 'data/Modals/actions'
import store from 'store/store'

interface IRenderRevokeStrikeModalProps {
  strikeId: number
  upshifterName: string
}

export const renderRevokeStrikeModal = ({
  strikeId,
  upshifterName,
}: IRenderRevokeStrikeModalProps) => {
  return store.dispatch(
    OpenModal({
      identifier: 'revoke-strike-modal',
      title: 'Revoke Strike',
      content:
        'This Upshifter has no call, no show strikes assigned for this shift. Do you want to revoke them?',
      showCancelButton: false,
      confirmButtonLabel: 'Yes, Revoke Strikes',
      onConfirm: () => {
        try {
          API.Strikes.putStrike(strikeId, {
            status: STRIKE_STATUS.REVOKED,
            reason_revoked: 'Business said Upshifter attended shift',
          })
          NotificationManager.success(`Strike for ${_.startCase(upshifterName)} has been revoked.`)
          store.dispatch(CloseModal('revoke-strike-modal'))
        } catch (error) {
          handleErrorNotification(error)
        }
      },
    })
  )
}
